import React, { FC, useCallback } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { Container } from "../../../components";
import { useFlag } from "../../../hooks/useFlag";
import { getAuthState, useLogout } from "../../auth";
import { HeaderConfirmLogoutModal } from "./HeaderConfirmLogoutModal";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderNavigationNew } from "./HeaderNavigationNew";
import { HeaderUserMenu } from "./HeaderUserMenu";

const StyledHeaderNew = styled.header`
  .HeaderNew__container {
    width: 100%;
    height: 56px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    background: ${({ theme }) => theme.colors.white};
    border-bottom: 1px solid ${({ theme }) => theme.colors.lightgrey};
  }

  .HeaderNew__end {
    display: flex;
    align-items: center;
    gap: 24px;
  }
`;

interface Props {}

const HeaderNew: FC<Props> = () => {
  const { name, userImage } = useSelector(getAuthState());
  const { handleLogout } = useLogout();

  const [isLogoutRequested, onRequestLogout, onCancelLogout] = useFlag(false);

  const handleConfirmLogout = useCallback(() => {
    onCancelLogout();
    handleLogout();
  }, [handleLogout, onCancelLogout]);

  return (
    <StyledHeaderNew data-cy="header-new">
      <Container className="HeaderNew__container">
        {/* In RTL flex: this group (first child) = right edge, avatar (second child) = left edge */}
        <div className="HeaderNew__end">
          {/* Within this group, logo (first child) = rightmost, nav (second child) = to its left */}
          <HeaderLogo />
          <HeaderNavigationNew />
        </div>

        <HeaderUserMenu
          userName={name}
          userImage={userImage}
          avatarVariant="dark"
          onRequestLogout={onRequestLogout}
        />

        {isLogoutRequested && (
          <HeaderConfirmLogoutModal
            onConfirm={handleConfirmLogout}
            onCancel={onCancelLogout}
          />
        )}
      </Container>
    </StyledHeaderNew>
  );
};

export { HeaderNew };
